export default "__VITE_ASSET__BX1n$WI4__"